import React from "react";
import { dataStatus } from "../config/dataConfig" ;

const DataNote = () => {
    return (
        <>
            <small className="text-muted">
                Datenstand: Einwohner {dataStatus.yearEinwohner}, Tagesbevölkerung {dataStatus.yearTagbev},
                <br/>GIP Fußwege {dataStatus.yearGIP}
            </small>
            <br />
            <small className="text-muted">
                Datenquellen: Statistik Austria, SAGIS, SVG
            </small>
        </>
    );
};

export default DataNote;